import { Backdrop, CircularProgress, LinearProgress } from "@mui/material";
import { tokens } from "../../../theme";

interface SpinnerProps {
  loading: boolean;
}

/**
 * Non-blocking progress bar pinned to the top of the viewport.
 *
 * This used to be a full-screen scrim plus CircularProgress, which invariant 4
 * forbids: it greys out content that already has a frame and blocks input for
 * reads the user never asked to wait on. Kept as one component with the same
 * `loading` prop so all ~28 call sites keep working unchanged.
 *
 * The end state per screen is a <Skeleton> shaped like the value it replaces —
 * see `pending()` in utils/missing, and <KpiCard>. That is per-screen work and
 * lands with each screen's port, not here.
 */
const Spinner = ({ loading }: SpinnerProps) => {
  // LEGACY — the old app blocked the screen while loading. It also never
  // early-returned: the Backdrop stayed mounted so MUI could fade it out, which
  // an unmount-on-false would turn into an abrupt disappearance. Delete this
  // branch with the rest of the legacy shell.
  if (tokens.shell === "legacy") {
    return (
      <Backdrop sx={{ color: "#fff", zIndex: (t) => t.zIndex.drawer + 1 }} open={Boolean(loading)}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (!loading) return null;

  return (
    <LinearProgress
      aria-label="Loading"
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        zIndex: (theme) => theme.zIndex.snackbar + 1,
        bgcolor: "transparent",
        "& .MuiLinearProgress-bar": { bgcolor: tokens.color.primary }
      }}
    />
  );
};

export default Spinner;
